import * as React from "react";
import PrimaryButton from "../../../Common/Buttons/PrimaryButton";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

type Props = {
    onLogin: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onClock: (e: React.MouseEvent<HTMLButtonElement>) => void;
    loadingClock?: boolean;
    loadingLogin?: boolean;
};

export default class LoginActions extends React.Component<Props> {
    public render(): React.ReactNode {
        let clockText = (
            <React.Fragment>
                <FontAwesomeLight icon="chess-clock" />Clock On / Off
            </React.Fragment>
        );

        if(this.props.loadingClock) {
            clockText = <FontAwesomeLight icon="spinner-third" spin />;
        }

        let loginText = (
            <React.Fragment>
                <FontAwesomeLight icon="sign-in" />Login
            </React.Fragment>
        );

        if(this.props.loadingLogin) {
            loginText = <FontAwesomeLight icon="spinner-third" spin />;
        }

        return (
            <div id="login-actions">
                {/*
                <Button
                    type="button"
                    classes={["clock-on-off-button"]}
                    onClick={this.props.onClock}
                >
                    {clockText}
                </Button>
                */}
                <PrimaryButton
                    type="button"
                    onClick={this.props.onLogin}
                    data-testid="sl-login-button"
                    disabled={this.props.loadingLogin}
                >
                    {loginText}
                </PrimaryButton>
            </div>
        );
    }
}
